import { Action, createReducer, on } from '@ngrx/store';

import {
  initialState,
  EntityEntidadesProductivaActividadState
} from './entity-entidades-productiva-actividad.state';
import { entityEntidadesProductivaActividadAdapter } from './entity-entidades-productiva-actividad.state';
import {
  entityEntidadesProductivaActividadLoadRequest,
  entityEntidadesProductivaActividadLoadSuccess,
  entityEntidadesProductivaActividadLoadFailure
  /* entityEntidadesProductivaActividadAddFailure,
  entityEntidadesProductivaActividadAddRequest,
  entityEntidadesProductivaActividadAddSuccess,
  entityEntidadesProductivaActividadChangeFailure,
  entityEntidadesProductivaActividadChangeRequest,
  entityEntidadesProductivaActividadChangeSuccess,
  entityEntidadesProductivaActividadDeleteFailure,
  entityEntidadesProductivaActividadDeleteRequest,
  entityEntidadesProductivaActividadDeleteSuccess*/
} from './entity-entidades-productiva-actividad.actions';

const reducer = createReducer(
  initialState,
  // load
  on(entityEntidadesProductivaActividadLoadRequest, (state) => ({
    ...state,
    isLoading: true,
    error: null
  })),
  on(entityEntidadesProductivaActividadLoadFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error: error
  })),
  on(entityEntidadesProductivaActividadLoadSuccess, (state, { items }) =>
    entityEntidadesProductivaActividadAdapter.addOne(items, {
      ...state,
      isLoading: false,
      error: null
    })
  )
  /*
  //add
  on(entityEntidadesProductivaActividadAddRequest, (state) => ({
    ...state,
    isLoading: true,
    error: null
  })),
  on(entityEntidadesProductivaActividadAddFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error: error
  })),
  on(entityEntidadesProductivaActividadAddSuccess, (state, { item }) =>
    entityEntidadesProductivaActividadAdapter.addOne(item, {
      ...state,
      isLoading: false,
      error: null
    })
  ),
  // change
  on(entityEntidadesProductivaActividadChangeRequest, (state) => ({
    ...state,
    isLoading: true,
    error: null
  })),
  on(entityEntidadesProductivaActividadChangeFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error: error
  })),
  on(entityEntidadesProductivaActividadChangeSuccess, (state, { item }) =>
    entityEntidadesProductivaActividadAdapter.updateOne(item, {
      ...state,
      isLoading: false,
      error: null
    })
  ),
  // delete
  on(entityEntidadesProductivaActividadDeleteRequest, (state) => ({
    ...state,
    isLoading: true,
    error: null
  })),
  on(entityEntidadesProductivaActividadDeleteFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error: error
  })),
  on(entityEntidadesProductivaActividadDeleteSuccess, (state, { item }) =>
    entityEntidadesProductivaActividadAdapter.removeOne(item.id, {
      ...state,
      isLoading: false,
      error: null
    })
  )*/
);

export function entidadesProductivaActividadReducer(
  state: EntityEntidadesProductivaActividadState | undefined,
  action: Action
) {
  return reducer(state, action);
}
